import loading from "@/common/loading/index.js";
import Toast from '@/common/toast/index.js'
import {getVerifyCode,bindPhone} from '@/api/login.js'
import {debounce} from '@/utils/common.js'

export default {
  name: "login",
  data () {
    return {
      phone: "",   // 电话号码实际值
      oldPhoneLen:0,  //上次键盘事件时输入的电话长度
      msgCode: "",  // 短信验证码
      codeBtnText: "获取验证码",
      disabledCodeBtn:true,//按钮置灰
      disabledLoginBtn:true,//按钮置灰
      countDown:61,
    }
  },
  watch: {
    phone(value){
      if(value.length==13&&this.countDown==61){
        this.disabledCodeBtn=false;
      }else if(value.length>13){
        Toast({
          "message": "手机号码不能超过11位",
          position: "",
          duration: 1000,
        });
        this.disabledCodeBtn=true;
      }else{
        this.disabledCodeBtn=true;
      }
    },
    msgCode(value){
      if(value.length==6 && this.phone.length==13){
        this.disabledLoginBtn = false
      }else{
        this.disabledLoginBtn=true
      }
    }

  },

  methods: {
    // 剪除空格
    trimSpace (text) {
      return text.replace(/\s+/g, "");
    },

    checkPhone:debounce(function(e){
      let element = e.target
      let value = element.value;
      let oldPosition = element.selectionStart;
      // this.phone = value.replace(/\D/g,'').replace(/....(?!$)/g, '$& ')
      this.phone = value.replace(/\D/g,'')
      this.phone = this.getPhoneWithPlaceholder(this.phone,' ')
      let phoneLen = this.phone.length
      this.$nextTick(()=>{
        //空格后并且是输入而非删除
        if((oldPosition===4||oldPosition===9)&&phoneLen>this.oldPhoneLen){
          oldPosition++
        }
        element.setSelectionRange(oldPosition, oldPosition);
        this.oldPhoneLen=this.phone.length
      })
    },0),

    // 手机号增加空格分割
    getPhoneWithPlaceholder (text, placeholder) {
      let arr = text.split(""),
        result = [];
      for(let i=0; i<arr.length; ++i) {
        if(i == 3 || (i-3) % 4 == 0) {
          result.push(placeholder);
        }
        result.push(arr[i]);
      }
      return result.join("");
    },

    // 手机号格式是否正确
    isPhoneAccessible() {
      let phoneTrimed = this.trimSpace(this.phone);
      let pattern = /^1\d{10}$/;
      return pattern.test(phoneTrimed);
    },

    /* 获取手机验证码 */
    getVerificationCode () {
      if(this.disabledCodeBtn){
        return
      }
      if(!this.phone || this.phone.length!==13) {
        Toast({
          "message": "请输入11位手机号码",
          position: "",
          duration: 1500,
        });
        return;
      }
      if(!this.isPhoneAccessible()) {
        Toast({
          "message": "手机号码格式不正确",
          position: "",
          duration: 1500,
        });
        return;
      }

      let data = {
        mobilePhone: this.trimSpace(this.phone),
      };

      // if(!this.imageCode) {
      //   data.imgCode = this.imageCode;
      // }
      loading.show();
      this.disabledCodeBtn=true
      getVerifyCode(data).then(res=>{
        loading.hide();
        Toast({
          message:'验证码发送成功，请查收',
          duration:2000
        })
      }).catch(error=>{
        console.log(error)
        loading.hide()
      })

      let self = this;
      // self.countDown = 61;      // 倒计时时间设置
      (function start() {
        if(self.countDown == 0) {
          self.reSend = true;
          self.codeBtnText = "重新发送";
          self.disabledCodeBtn=false;
          self.countDown=61;
          return false;
        }
        self.countDown = self.countDown - 1;
        self.codeBtnText = `${self.countDown}s`;
        window.setTimeout(start, 1000);
      })();
    },

    /* 请求登录 */
    requestLogin () {
      if(this.disabledLoginBtn){
        return
      }
      if(!this.isPhoneAccessible()) {
        Toast({
          "message": "请输入手机号码",
          position: "top",
          duration: 1500,
        });
        return;
      }
      let data = {
        bindPhone: this.trimSpace(this.phone),
        verifyCode: this.msgCode,
      };
      loading.show();
      bindPhone(data).then((res)=>{
        loading.hide();
        Toast({
          message:'登录成功',
          duration:1000
        })
        this.$router.back();
      }).catch((error=>{
        console.log(error)
        loading.hide();
      }))
    },
  },
  
}
